import { createFileRoute, redirect } from "@tanstack/react-router";

/** The catalog opens on its services. */
export const Route = createFileRoute("/_app/catalog/")({
  beforeLoad: () => {
    throw redirect({ to: "/catalog/services", replace: true });
  },
});
